var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 3.51472 4.01472 1.5 6.5 1.5H18.5C20.9853 1.5 23 3.51472 23 6V18C23 20.4853 20.9853 22.5 18.5 22.5H6.5C4.01472 22.5 2 20.4853 2 18V6ZM6.5 2.5C4.567 2.5 3 4.067 3 6V18C3 19.933 4.567 21.5 6.5 21.5H18.5C20.433 21.5 22 19.933 22 18V6C22 4.067 20.433 2.5 18.5 2.5H6.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.309 11.5C10.1384 11.5 10 11.6384 10 11.809V16.191C10 16.3616 10.1384 16.5 10.309 16.5C10.357 16.5 10.4043 16.4888 10.4472 16.4674L14.8292 14.2764C14.9339 14.224 15 14.117 15 14C15 13.883 14.9339 13.776 14.8292 13.7236L10.4472 11.5326C10.4043 11.5112 10.357 11.5 10.309 11.5ZM9 11.809C9 11.0861 9.58607 10.5 10.309 10.5C10.5122 10.5 10.7127 10.5473 10.8944 10.6382L15.2764 12.8292C15.7199 13.0509 16 13.5042 16 14C16 14.4958 15.7199 14.9491 15.2764 15.1708L10.8944 17.3618C10.7127 17.4527 10.5122 17.5 10.309 17.5C9.58607 17.5 9 16.9139 9 16.191V11.809ZM2 8C2 7.72386 2.22386 7.5 2.5 7.5H22.5C22.7761 7.5 23 7.72386 23 8C23 8.27614 22.7761 8.5 22.5 8.5H2.5C2.22386 8.5 2 8.27614 2 8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6582 1.5258C10.9202 1.61312 11.0618 1.89628 10.9745 2.15825L8.97448 8.15825C8.88715 8.42022 8.60399 8.5618 8.34202 8.47448C8.08005 8.38716 7.93847 8.104 8.02579 7.84202L10.0258 1.84202C10.1131 1.58005 10.3963 1.43847 10.6582 1.5258ZM16.6582 1.5258C16.9202 1.61312 17.0618 1.89628 16.9745 2.15825L14.9745 8.15825C14.8872 8.42022 14.604 8.5618 14.342 8.47448C14.0801 8.38716 13.9385 8.104 14.0258 7.84202L16.0258 1.84202C16.1131 1.58005 16.3963 1.43847 16.6582 1.5258Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReel);
export default __webpack_public_path__ + "static/media/reel.cdf9c89f225dd5e7fa37eeda77894ed3.svg";
export { ForwardRef as ReactComponent };